// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroBlock_root__piwNH"};